var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.58301,
    y: 3.25,
    width: 16.8333,
    height: 13.5,
    rx: 4.25,
    fill: "white",
    stroke: "#4F4F4F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13487 7.08642V6.84331C7.13487 6.47788 6.83863 6.18164 6.47319 6.18164C6.10776 6.18164 5.81152 6.47788 5.81152 6.84331V7.08642C5.81152 7.45185 6.10776 7.74809 6.47319 7.74809C6.83863 7.74809 7.13487 7.45185 7.13487 7.08642Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13487 13.3517V13.1089C7.13487 12.7435 6.83863 12.4473 6.47319 12.4473C6.10776 12.4473 5.81152 12.7435 5.81152 13.1089V13.3517C5.81152 13.7171 6.10776 14.0133 6.47319 14.0133C6.83863 14.0133 7.13487 13.7171 7.13487 13.3517Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13487 10.2184V9.97564C7.13487 9.6102 6.83863 9.31396 6.47319 9.31396C6.10776 9.31396 5.81152 9.61021 5.81152 9.97564V10.2184C5.81152 10.5838 6.10776 10.88 6.47319 10.88C6.83863 10.88 7.13487 10.5838 7.13487 10.2184Z",
    fill: "#4F4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 12.0832L15.0007 7.91553",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9978 12.694C14.8356 12.694 14.6816 12.6291 14.568 12.5156C14.5113 12.4588 14.4707 12.3859 14.4383 12.3129C14.4059 12.2399 14.3896 12.1678 14.3896 12.0859C14.3896 12.0048 14.4059 11.9237 14.4383 11.8507C14.4707 11.7777 14.5113 11.7129 14.568 11.6561C14.7951 11.4291 15.2005 11.4291 15.4275 11.6561C15.4843 11.7129 15.5329 11.7777 15.5654 11.8507C15.5897 11.9237 15.6059 12.0048 15.6059 12.0859C15.6059 12.1678 15.5897 12.2399 15.5654 12.3129C15.5329 12.3859 15.4843 12.4588 15.4275 12.5156C15.314 12.6291 15.1599 12.694 14.9978 12.694Z",
    fill: "#4F4F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8298 8.52663C10.7487 8.52663 10.6757 8.5096 10.6028 8.47717C10.5298 8.44473 10.4568 8.405 10.4001 8.34824C10.3433 8.28338 10.3028 8.21851 10.2703 8.14553C10.2379 8.07175 10.2217 7.99958 10.2217 7.9185C10.2217 7.8366 10.2379 7.75633 10.2703 7.68336C10.3028 7.61038 10.3433 7.53741 10.4001 7.48876C10.6352 7.26091 11.0325 7.26091 11.2596 7.48876C11.3731 7.60146 11.4379 7.75633 11.4379 7.9185C11.4379 7.99958 11.4298 8.07175 11.3974 8.14553C11.365 8.21851 11.3163 8.28338 11.2596 8.34824C11.2028 8.405 11.1379 8.44473 11.065 8.47717C10.992 8.5096 10.9109 8.52663 10.8298 8.52663Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.fed35412.svg";
export { ForwardRef as ReactComponent };